/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSupportRequestDto } from '../../models/backend-support-request-dto';

export interface SupportCreateCreate$Params {}

export function supportCreateCreate(
  http: HttpClient,
  rootUrl: string,
  params?: SupportCreateCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSupportRequestDto>> {
  const rb = new RequestBuilder(rootUrl, supportCreateCreate.PATH, 'post');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSupportRequestDto>;
    }),
  );
}

supportCreateCreate.PATH = '/api/support/create/';
